module.exports = __webpack_public_path__ + "media/audio80.6d6c37f3.mp3";